const toDate = (timestamp) => {
  if (!timestamp) return null;
  if (typeof timestamp.toDate === "function") return timestamp.toDate();
  if (timestamp instanceof Date) return timestamp;
  return null;
};

const startOfDay = (date) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate());

// Groups conversations into "Vandaag" (today), "Deze week" (previous 6 days)
// and "Eerder" (older / undated). Groups keep the input order of their items
// and only non-empty groups are returned, always in this fixed order.
const groupConversationsByDate = (conversations = [], now = new Date()) => {
  const todayStart = startOfDay(now);
  const weekStart = new Date(todayStart);
  weekStart.setDate(weekStart.getDate() - 6);

  const buckets = { Vandaag: [], "Deze week": [], Eerder: [] };

  conversations.forEach((conversation) => {
    const date = toDate(conversation.Timestamp);

    if (date && date >= todayStart) {
      buckets.Vandaag.push(conversation);
    } else if (date && date >= weekStart) {
      buckets["Deze week"].push(conversation);
    } else {
      buckets.Eerder.push(conversation);
    }
  });

  return ["Vandaag", "Deze week", "Eerder"]
    .filter((name) => buckets[name].length > 0)
    .map((name) => ({ name, items: buckets[name] }));
};

export default groupConversationsByDate;
